import dayjs, {ISO_DATE_FORMATS} from "@/utils/dayjs";
import AbsEditViewValueFormatter from "@/utils/UIConstants/AGGridEditViewValueFormatters/AbsEditViewValueFormatter.ts";

export default class DateTimeValueFormatter extends AbsEditViewValueFormatter {
  private static _instance: DateTimeValueFormatter;

  static instance() {
    if (!this._instance)
      this._instance = new DateTimeValueFormatter();
    return this._instance;
  }

  override format(specs: namaTypes.DTOFieldSpecs | null | undefined, value: any) {
    if (!value)
      return '';
    return dayjs(value, ISO_DATE_FORMATS).format("YYYY-MM-DD HH:mm");
  }

  override parse(specs: namaTypes.DTOFieldSpecs | null | undefined, value: any) {
    if (!value || !dayjs(value, ISO_DATE_FORMATS).isValid())
      return '';
    return dayjs(value, ISO_DATE_FORMATS).format("YYYY-MM-DD HH:mm:ss.SSS");
  }
}
